import { findRunByIdOrAlias } from '@shared-lib/cabinet-runs/runIds';
import { runCabinetryMembership } from './cabinetRunGeometry';

/**
 * WHICH objects the canvas lights when the CABINET RUN is the edit target.
 *
 * One rule, two renderers: the 2D floor plan (`2d/useFloorplanRenderer.js`) and
 * the 3D scene (`StructureViewerWrapper`). They had a copy each, and the copies
 * disagreed — 2D asked `runCabinetryMembership` alone, which is gated on the
 * cabinetry TYPES, so a run-owned countertop, range or dishwasher was left dark
 * on the plan while the 3D scene lit it. The union with the raw `runId` is what
 * makes the answer "everything this run owns" rather than "every box this run
 * owns".
 *
 * `cabinetEditScope` is the gate, not a filter applied afterwards: in BAY scope
 * the answer is empty, because the bay panel's edit target is the one box the
 * user clicked and the pink has to say so (`hooks/useCabinetEditScope`).
 *
 * Returns the member ids INCLUDING the selected object's own — every caller
 * paints it anyway, and leaving it out made "the whole run" a set that pointedly
 * excluded the thing the user clicked.
 */
export function runScopeHighlightIds({
  rooms,
  selectedObject,
  cabinetEditScope,
}) {
  const ids = new Set();
  if (cabinetEditScope !== 'run' || !selectedObject?.runId) return ids;
  for (const room of rooms || []) {
    if (!room) continue;
    const stored = findRunByIdOrAlias(room.cabinetRuns, selectedObject.runId);
    const member = stored ? runCabinetryMembership(stored) : null;
    for (const o of room.objects || []) {
      if (!o?.id) continue;
      if (o.runId === selectedObject.runId || (member && member(o)))
        ids.add(o.id);
    }
  }
  return ids;
}
